import React, { useEffect, useState, useRef} from "react";
import store from "@/redux/store";
import { useNavigate, Link } from "react-router-dom";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon, DocumentIcon } from '@heroicons/react/20/solid'
import { Profile } from "@/views/base/user/Profile";
import { OverviewDocuments } from "./OverviewDocuments";
import {getUserDocuments} from "@/reducers/Document";
import { getRoleForUser } from '@/reducers/Roles'

import { RoleDetail } from "./RoleDetail";
import { RolesModel } from "@/models/Roles";

import { useForm, SubmitHandler, Controller, useFormState } from "react-hook-form"
import  {IUser} from "@/models/User";
import  {IAddress} from "@/models/interfaces";
import { WorkHoursView } from "./Workhours";

export function Detail({...props}) {
    const roleDetailView = useRef(null); 
const [selectedTab, setSelectedTab] = useState(1)
let saveWith = false;

const tabs = [

  {tabId: 1,  name: 'Profiel gegevens', href: '#', icon: UserIcon, current: true },
  {tabId: 2,  name: 'Documenten', href: '#', icon: DocumentIcon, current: false },
  {tabId: 3,  name: 'Rechten', href: '#', icon: DocumentIcon, current: false },
  //{tabId: 4,  name: 'Werkuren', href: '#', icon: DocumentIcon, current: false },
  
  
//  { name: 'Bedrijf', href: '#', icon: BuildingOfficeIcon, current: false },
//  { name: 'Billing', href: '#', icon: CreditCardIcon, current: false },
]  // More people...

  const {getFieldState, register, handleSubmit, watch, reset, control, setValue, getValues, 
  formState: {  isDirty, dirtyFields, isSubmitSuccessful } } = useForm({
      defaultValues: props?.data 
    })

    
/*
useEffect(() => {
  const { unsubscribe } = watch((value) => {
    store.dispatch(messageActions.receiveMessage2(value))
  })
  return () => unsubscribe()
}, [watch])
*/

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const setTab = (tabId) => {
    if(tabId == 2) {
        store.dispatch( getUserDocuments(props?.data)).then((value) => {
            });
     }
    if(tabId == 3) {
        if(!props?.userReducer?.selected?.rights) {
        store.dispatch( getRoleForUser(props?.userReducer?.selected.key)).then((value) => {
            if(!props?.userReducer?.selected?.rights) {
                
                props.userReducer.selected.rights = props.RolesReducer?.selected;
                
            }
            
            });
         } else {
             //props.RolesReducer.selected = props.userReducer.selected.rights;
         }
         saveWith = true;
     }
    
    setSelectedTab(tabId);
    }


  const onSaveWrapped = (data) => {
    event.preventDefault();
    event.stopPropagation();
    
    
    
    
    
    
        
        
        
        console.debug(getFieldState('first_name'));
        data.rights = props.userRoles.selected;
    if(saveWith) {
        //data.rights = props.RolesReducer?.selected;
        //saveWith = false;
    }
    if(props.onSaveHandler) {
        props.onSaveHandler(props?.data);
    }
      
    return false;
  };

    const onSaveRoleHandler = (data) => {
        
        
        return false;
        };
        
        if(props?.data) {
//        let changeObj = props?.data?.getProxy();
 //       changeObj.first_name = 'KARELTJE';
        
        }
  return (
    <>

    <div className="px-4 sm:px-6 lg:px-8">

    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.current).name}
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                onClick={() => setTab(tab.tabId)}
                aria-current={tab.current ? 'page' : undefined}
                className={classNames(
                  tab.tabId == selectedTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium',
                )}
              >
                <tab.icon
                  aria-hidden="true"
                  className={classNames(
                    tab.tabId == selectedTab ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500',
                    '-ml-0.5 mr-2 h-5 w-5',
                  )}
                />
                <span>{tab.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
    
    <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSaveWrapped)}>
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to={(props.data && props.data.type == 1) ? "/team" : "/ext-team"} type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
    
{selectedTab == 1 &&
    <Profile {...props} onSaveHandler={onSaveWrapped} key={(props.data && props.data.key) ? props.data.key : "EM"} register={register} setValue={setValue} getValues={getValues} control={control}/>
    }
{selectedTab == 2 &&
    <OverviewDocuments {...props} key={(props.data && props.data.key) ? props.data.key : "EM"} documents={props?.userDocuments} isTeam={true} user={props.data}/>
    }
{selectedTab == 3 &&
    <RoleDetail ref={roleDetailView} data={props.userRoles} sectors={props?.sectors}  onSaveHandler={onSaveRoleHandler} noRoleName
    register={register} setValue={setValue} getValues={getValues} registerkey={`userfields.`} control={control}  state={props.state} user={props?.data}
    />
    }
{selectedTab == 4 &&
    <WorkHoursView />
    }
    
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to={(props.data && props.data.type == 1) ? "/team" : "/ext-team"} type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
    
    
    </form>
    </div>



    </>
      );
}
